((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.DIMStorefrontDisplay = api;
})(typeof window !== 'undefined' ? window : globalThis, () => {
  'use strict';
  const numeric = (value, kind) => {
    const text = String(value || '');
    const id = text.startsWith(`gid://shopify/${kind}/`) ? text.slice(`gid://shopify/${kind}/`.length) : text;
    if (!/^[1-9][0-9]*$/.test(id)) throw new Error('DISPLAY_MISMATCH');
    return id;
  };
  const offerings = display => {
    if (!display || !Array.isArray(display.offerings) || !display.offerings.length || display.offerings.length > 100) throw new Error('DISPLAY_MISMATCH');
    const seen = new Set();
    return display.offerings.map(item => {
      const productId = numeric(item.productId, 'Product');
      if (seen.has(productId) || !Array.isArray(item.variantIds) || !item.variantIds.length || item.variantIds.length > 100) throw new Error('DISPLAY_MISMATCH');
      seen.add(productId);
      const variantIds = item.variantIds.map(id => numeric(id, 'ProductVariant'));
      if (new Set(variantIds).size !== variantIds.length) throw new Error('DISPLAY_MISMATCH');
      return { productId, variantIds };
    });
  };
  const singleSelection = display => {
    const offer = offerings(display);
    return offer.length === 1 && offer[0].variantIds.length === 1 ? { productId: offer[0].productId, variantId: offer[0].variantIds[0] } : null;
  };
  const allows = (display, productId, variantId) => offerings(display).some(item => item.productId === String(productId) && item.variantIds.includes(String(variantId)));
  const focusedContext = (runtime, context = runtime?.context) => Boolean(context && (
    runtime?.runtime?.environment === 'development' && context.purpose === 'staff-preview'
    || runtime?.runtime?.environment === 'production' && context.mode === 'alias' && context.purpose === 'customer'
  ));
  const scopeProductOptions = (select, display) => {
    const offer = offerings(display);
    const byProduct = new Map(offer.map(item => [item.productId, item]));
    const retained = [];
    for (const option of Array.from(select?.options || [])) {
      if (!option.value) continue;
      const allowed = byProduct.get(String(option.value));
      if (!allowed) { option.remove(); continue; }
      let variants;
      try { variants = JSON.parse(option.dataset.variants); } catch (_) { throw new Error('DISPLAY_MISMATCH'); }
      if (!Array.isArray(variants)) throw new Error('DISPLAY_MISMATCH');
      const exact = variants.filter(variant => allowed.variantIds.includes(String(variant.id)) && variant.available === true);
      if (!exact.length) { option.remove(); continue; }
      option.dataset.variants = JSON.stringify(exact);
      retained.push(option);
    }
    // Product merchandising order belongs to the saved offer, not the global collection.
    offer.forEach(item => { const option = retained.find(value => String(value.value) === item.productId); if (option) select.appendChild(option); });
    return retained;
  };
  const resolveMedia = (assets, media = assets) => {
    if (!Array.isArray(assets) || !Array.isArray(media)) return [];
    return assets.flatMap(asset => {
      const exact = media.filter(item => item.assetId === asset.assetId);
      if (exact.length !== 1) return [];
      let url;
      try { url = new URL(exact[0].url); } catch (_) { return []; }
      if (url.protocol !== 'https:' || url.username || url.password || url.hash || url.hostname !== 'cdn.shopify.com') return [];
      return [{ ...asset, url: url.href, width: exact[0].width, height: exact[0].height }];
    });
  };
  return Object.freeze({ offerings, singleSelection, allows, scopeProductOptions, resolveMedia, focusedContext });
});
